import HeroBg from "public/certificationLabs/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Upgrade your IT skills with certification labs",
    link: "contact-us",
  },
  title: "Cloud-Based Training & Certification Labs",
  desc: "Hands-on cloud training labs. Gain real-world experience, master in-demand skills, and earn industry-recognized certifications.",
  image: HeroBg,
  cmlPowered: true,
};
